import script from "./FormulasApeTicketItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasApeTicketItems.vue?vue&type=script&setup=true&lang=js"

import "./FormulasApeTicketItems.vue?vue&type=style&index=0&id=126c0666&lang=scss"

const __exports__ = script;

export default __exports__